import { memo, useRef } from "react";
import { bool, string, func, object, oneOf } from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, PopMenu } from "@components";
import { DialogTitle, Grid, IconButton } from "@material-ui/core";
import { ColorPickerInner } from "@components/ColorPicker/components/ColorPickerInner";
import { Close } from "@material-ui/icons";
import useStyle from "@components/ColorPicker/ColorPicker.style";

export const ColorPicker = memo(({
  show,
  onClose,
  onChange,
  onAccept,
  anchor,
  title,
  type,
  requireAccept,
  revertOnCancel,
  originalColor: remoteOriginalColor,
  initialColor,
  acceptButtonTitle,
  cancelButtonTitle,
  placement="right-start",
  ...innerProps
}) => {
  const { t } = useTranslation();
  const classes = useStyle();
  
  const ref = useRef({
    originalColor: remoteOriginalColor || initialColor,
    pickedColor: initialColor
  });
  // const [originalColor] = useState(remoteOriginalColor || initialColor);
  // const [pickedColor, setPickedColor] = useState(initialColor);
  
  const handleChange = (hex) => {
    // setPickedColor(hex);
    ref.current.pickedColor = hex;
    
    if(!requireAccept || revertOnCancel)
      onChange?.(hex);
  }
  
  const handleAccept = () => {
    onAccept?.(ref.current.pickedColor);
    onClose();
  }
  
  const handleCancel = () => {
    if(revertOnCancel)
      onChange?.(ref.current.originalColor);
    onClose();
  }
  
  return (
    <PopMenu
      show={show}
      anchor={anchor}
      onClickAway={onClose}
      style={{ width: 376 }}
      placement={placement}
    >
      {
        (title || !requireAccept) &&
        <DialogTitle disableTypography className="w-full p-4">
          {
            title &&
            <h2 className="text-xl font-bold">
              {
                type
                  ? `${ title } - ${ t(`color_picker_types.${ type }`) }`
                  : title
              }
            </h2>
          }
          {
            !requireAccept &&
            <IconButton
              className="p-0"
              color="primary"
              aria-label="close modal"
              onClick={ onClose }
            >
              <Close />
            </IconButton>
          }
        </DialogTitle>
      }
      <ColorPickerInner
        onChange={handleChange}
        initialColor={ref.current.originalColor}
        {...innerProps}
      />
      {
        !!onAccept &&
        <Grid
          item container
          justifyContent="flex-end"
          className={classes.acceptButtonContainer}
        >
          <Button
            variant="outlined"
            className="mr-2"
            onClick={handleCancel}
          >
            {cancelButtonTitle || t("common.cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={handleAccept}
          >
            {acceptButtonTitle || t("common.add")}
          </Button>
        </Grid>
      }
    </PopMenu>
  );
})

ColorPicker.propTypes = {
  onClose: func.isRequired,
  show: bool,
  anchor: object,
  originalColor: string,
  initialColor: string,
  revertOnCancel: bool,
  title: string,
  onChange: func,
  onAccept: func,
  onFocus: func,
  onBlur: func,
  type: oneOf(["font","background","border"]),
  requireAccept: bool,
  acceptButtonTitle: string,
  cancelButtonTitle: string,
  placement: oneOf([
    "top",
    "top-start",
    "top-end",
    "bottom-start",
    "bottom",
    "bottom-end",
    "left-start",
    "left",
    "left-end",
    "right-start",
    "right",
    "right-end",
  ]),
};
